import { MedplumClient } from '@medplum/core';
import { Coding } from '@medplum/fhirtypes';

/**
 * Loads concepts from a CodeSystem by URL and returns them as Coding objects
 * @param medplum - Medplum client instance
 * @param url - The URL of the CodeSystem to load
 * @returns Promise that resolves to an array of Coding objects, or empty array if CodeSystem not found
 */
export async function expandCodeSystem(medplum: MedplumClient, url: string): Promise<Coding[] | null> {
  try {
    const codeSystem = await medplum.searchOne('CodeSystem', { url });

    if (!codeSystem) {
      return null;
    }

    return (codeSystem.concept || [])
      .filter((concept) => concept.code)
      .map(
        (concept) =>
          ({
            system: codeSystem.url,
            code: concept.code,
            display: concept.display ?? concept.code,
          }) as Coding
      );
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(`Failed to expand CodeSystem ${url}:`, error);
    return null;
  }
}
